import React from 'react';
export function Footer() {
  return <footer className="bg-slate-950 text-slate-400 py-12 px-6" data-id="element-22">
      <div className="max-w-7xl mx-auto" data-id="element-23">
        <div className="text-center mb-8" data-id="element-24">
          <p className="text-lg font-semibold text-slate-300 mb-4" data-id="element-25">
            Compliant, Transparent, Results-Driven Pay-Per-Call Marketing
          </p>
        </div>

        <div className="border-t border-slate-800 pt-8" data-id="element-26">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-27">
            <p className="text-sm" data-id="element-28">© 2025 Growthlyfe. All rights reserved.</p>
            <div className="flex gap-6 text-sm" data-id="element-29">
              <a href="#" className="hover:text-emerald-500 transition-colors duration-200" data-id="element-30">
                Privacy Policy
              </a>
              <a href="#" className="hover:text-emerald-500 transition-colors duration-200" data-id="element-31">
                Terms of Service
              </a>
              <a href="#" className="hover:text-emerald-500 transition-colors duration-200" data-id="element-32">
                Do Not Sell My Info
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>;
}